import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6a90ef8b&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90ef8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a90ef8b')) {
      api.createRecord('6a90ef8b', component.options)
    } else {
      api.reload('6a90ef8b', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6a90ef8b&scoped=true", function () {
      api.rerender('6a90ef8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/components/setting-design/main.vue"
export default component.exports